module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "col-sm-2 col-sm-offset-3",
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-sm-2",
    attrs: {
      "src": require("./assets/d3.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-sm-3",
    staticStyle: {
      "margin-top": "-25px"
    },
    attrs: {
      "src": require("./assets/uxgraph.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n      Developed by: "), _c('a', {
    attrs: {
      "href": "https://github.com/lirael"
    }
  }, [_vm._v("Olena Pastushenko")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459f4bae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 40
// module chunks = 0